// M4 Sales & Order Management — data-testid registry.
export const SALES = {
  navSales: "nav-sales",
  navNewSales: "nav-new-sales",

  // List
  listTable: "sales-table",
  listRow: (id) => `sales-row-${id}`,
  searchInput: "sales-search-input",
  statusFilter: "sales-status-filter",
  pagePrev: "sales-page-prev",
  pageNext: "sales-page-next",
  newBtn: "sales-new-btn",

  // New order form
  newCustName: "new-cust-name",
  newCustMobile: "new-cust-mobile",
  newCustEmail: "new-cust-email",
  newCustType: "new-cust-type",
  newCustCompany: "new-cust-company",
  newCustGstin: "new-cust-gstin",

  newBillAddr1: "new-bill-addr1",
  newBillAddr2: "new-bill-addr2",
  newBillCity: "new-bill-city",
  newBillState: "new-bill-state",
  newBillPincode: "new-bill-pincode",

  newShipSameAsBill: "new-ship-same-as-bill",
  newShipName: "new-ship-name",
  newShipMobile: "new-ship-mobile",
  newShipAddr1: "new-ship-addr1",
  newShipCity: "new-ship-city",
  newShipState: "new-ship-state",
  newShipPincode: "new-ship-pincode",

  newLineSearch: "new-line-search",
  newLineSearchBtn: "new-line-search-btn",
  newLineResult: (pid) => `new-line-result-${pid}`,
  newLineAdd: (pid) => `new-line-add-${pid}`,
  newLineRemove: (idx) => `new-line-remove-${idx}`,
  newLinePrice: (idx) => `new-line-price-${idx}`,
  newLineDiscount: (idx) => `new-line-discount-${idx}`,
  newLineGst: (idx) => `new-line-gst-${idx}`,
  newRemarks: "new-sales-remarks",
  newSubmit: "new-sales-submit",
  newCancel: "new-sales-cancel",
  newSummary: "new-sales-summary",

  // Detail
  detailHeader: "sales-detail-header",
  detailStatus: "sales-detail-status",
  detailPayStatus: "sales-detail-payment-status",
  confirmBtn: "sales-confirm-btn",
  dispatchBtn: "sales-dispatch-btn",
  completeBtn: "sales-complete-btn",
  cancelBtn: "sales-cancel-btn",
  cancelReason: "sales-cancel-reason",
  cancelSubmit: "sales-cancel-submit",
  invoiceBtn: "sales-invoice-btn",
  invoiceDownload: "sales-invoice-download",

  // Payments
  payAdd: "pay-add-btn",
  payMethod: "pay-method",
  payAmount: "pay-amount",
  payReference: "pay-reference",
  payRemarks: "pay-remarks",
  paySubmit: "pay-submit",
};
